import { useState, useRef } from 'react'
import cn from 'classnames'
import PropTypes from 'prop-types'
import { PopupButton } from '@typeform/embed-react'

import { ReactComponent as IconQuestion } from 'assets/icons/IconQuestion.svg'
import { ReactComponent as IconLogo } from 'assets/icons/IconLogo.svg'
import { ReactComponent as IconLogoMobile } from 'assets/icons/IconLogoMobile.svg'
import { ReactComponent as IconHamburger } from 'assets/icons/IconHamburger.svg'
import useClickOutside from 'hooks/useClickOutside'

const TopNavbar = ({ toggleSidebarActive, isBanner }) => {
  const [isDropdown, setIsDropdown] = useState(false)
  const dropdownRef = useRef(null)
  const buttonRef = useRef(null)

  useClickOutside(dropdownRef, buttonRef, setIsDropdown, isDropdown)

  const toggleDropdown = () => setIsDropdown(!isDropdown)

  return (
    <section
      className={cn('top-navbar-wrapper', { '-isBanner': isBanner })}
    >
      <div className="top-navbar">
        <IconLogo className="top-navbar__desktop-logo" />
        <div className="top-navbar__mobile-icons">
          <button
            className="top-navbar__hamburger"
            onClick={toggleSidebarActive}
            type="button"
          >
            <IconHamburger />
          </button>
          <IconLogoMobile />
        </div>
        <button
          ref={buttonRef}
          className="top-navbar__search"
          onClick={toggleDropdown}
          type="button"
        >
          <IconQuestion />
        </button>
        {isDropdown && (
          <div ref={dropdownRef} className="top-navbar__dropdown">
            <ul className="top-navbar__list">
              <li className="top-navbar__list-item">
                <span className="top-navbar__list-item-label">
                  Support Phone Number
                </span>
                <a
                  href="tel:18882762108,,4,4444,,2"
                  className="top-navbar__list-item-contact -phone"
                >
                  (888) 276-2108 ext. 4444
                </a>
              </li>
              <li className="top-navbar__list-item">
                <span className="top-navbar__list-item-label">
                  Support Email
                </span>
                <a
                  href="mailto:help@venuenext.com"
                  className="top-navbar__list-item-contact"
                >
                  help@venuenext.com
                </a>
              </li>
              <li className="top-navbar__list-item">
                <span className="top-navbar__list-item-label">
                  Support Page
                </span>
                <a
                  href="https://support.venuenext.net/"
                  className="top-navbar__list-item-contact"
                >
                  https://support.venuenext.net/
                </a>
              </li>
              <li className="top-navbar__list-item">
                <span className="top-navbar__list-item-label">
                  Shift4 Status Page
                </span>
                <a
                  href="https://shift4payments.statuspage.io"
                  className="top-navbar__list-item-contact"
                >
                  https://shift4payments.statuspage.io
                </a>
              </li>
              <li className="top-navbar__list-item">
                <span className="top-navbar__list-item-label">
                  General Comments
                </span>
                <PopupButton
                  id="H5QZ7xdj"
                  className="top-navbar__list-item-contact"
                >
                  Provide Feedback
                </PopupButton>
              </li>
            </ul>
          </div>
        )}
      </div>
    </section>
  )
}

TopNavbar.propTypes = {
  toggleSidebarActive: PropTypes.func,
  isBanner: PropTypes.bool,
}

export default TopNavbar
